// extracted by mini-css-extract-plugin
module.exports = {"social_media":"social-media_social_media__Uw3p4","dark":"social-media_dark__vuSzh"};